(function () {
  'use strict';

  function initBoard(board) {
    if (!board || board.swiper || typeof Swiper === 'undefined') return;

    var pagination = board.parentElement
      ? board.parentElement.querySelector('.cm-collective__pagination')
      : board.querySelector('.cm-collective__pagination');

    new Swiper(board, {
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: true,
      watchOverflow: true,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      pagination: pagination
        ? {
            el: pagination,
            clickable: true
          }
        : undefined
    });
  }

  function init() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.cm-collective__board--mobile').forEach(initBoard);
  }

  function start() {
    if (typeof Swiper !== 'undefined') {
      init();
      return;
    }
    window.addEventListener('load', init, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var board = event.target.querySelector('.cm-collective__board--mobile');
    initBoard(board);
  });
})();
